/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BlogPost,
  BlogPostCreate,
  BlogPostUpdate,
  HTTPValidationError,
} from '../models/index';
import {
    BlogPostFromJSON,
    BlogPostToJSON,
    BlogPostCreateFromJSON,
    BlogPostCreateToJSON,
    BlogPostUpdateFromJSON,
    BlogPostUpdateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface CreateBlogPostApiV1BlogPostsPostRequest {
    blogPostCreate: BlogPostCreate;
}

export interface CreateBlogPostApiV1BlogPostsPost0Request {
    blogPostCreate: BlogPostCreate;
}

export interface DeleteBlogPostApiV1BlogPostsIdDeleteRequest {
    id: number;
}

export interface ReadBlogPostByIdApiV1BlogPostsIdGetRequest {
    id: number;
}

export interface ReadBlogPostsApiV1BlogPostsGetRequest {
    skip?: number;
    limit?: number;
    categories?: Array<number>;
    tags?: Array<string>;
}

export interface ReadBlogPostsApiV1BlogPostsGet0Request {
    skip?: number;
    limit?: number;
    categories?: Array<number>;
    tags?: Array<string>;
}

export interface UpdateBlogPostApiV1BlogPostsIdPutRequest {
    id: number;
    blogPostUpdate: BlogPostUpdate;
}

/**
 * 
 */
export class BlogPostsApi extends runtime.BaseAPI {

    /**
     * Create new blog post.
     * Create Blog Post
     */
    async createBlogPostApiV1BlogPostsPostRaw(requestParameters: CreateBlogPostApiV1BlogPostsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlogPost>> {
        if (requestParameters['blogPostCreate'] == null) {
            throw new runtime.RequiredError(
                'blogPostCreate',
                'Required parameter "blogPostCreate" was null or undefined when calling createBlogPostApiV1BlogPostsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/blog-posts/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BlogPostCreateToJSON(requestParameters['blogPostCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogPostFromJSON(jsonValue));
    }

    /**
     * Create new blog post.
     * Create Blog Post
     */
    async createBlogPostApiV1BlogPostsPost(requestParameters: CreateBlogPostApiV1BlogPostsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlogPost> {
        const response = await this.createBlogPostApiV1BlogPostsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new blog post.
     * Create Blog Post
     */
    async createBlogPostApiV1BlogPostsPost_1Raw(requestParameters: CreateBlogPostApiV1BlogPostsPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlogPost>> {
        if (requestParameters['blogPostCreate'] == null) {
            throw new runtime.RequiredError(
                'blogPostCreate',
                'Required parameter "blogPostCreate" was null or undefined when calling createBlogPostApiV1BlogPostsPost_1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/blog-posts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BlogPostCreateToJSON(requestParameters['blogPostCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogPostFromJSON(jsonValue));
    }

    /**
     * Create new blog post.
     * Create Blog Post
     */
    async createBlogPostApiV1BlogPostsPost_1(requestParameters: CreateBlogPostApiV1BlogPostsPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlogPost> {
        const response = await this.createBlogPostApiV1BlogPostsPost_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a blog post.
     * Delete Blog Post
     */
    async deleteBlogPostApiV1BlogPostsIdDeleteRaw(requestParameters: DeleteBlogPostApiV1BlogPostsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlogPost>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteBlogPostApiV1BlogPostsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/blog-posts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogPostFromJSON(jsonValue));
    }

    /**
     * Delete a blog post.
     * Delete Blog Post
     */
    async deleteBlogPostApiV1BlogPostsIdDelete(requestParameters: DeleteBlogPostApiV1BlogPostsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlogPost> {
        const response = await this.deleteBlogPostApiV1BlogPostsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific blog post by id.
     * Read Blog Post By Id
     */
    async readBlogPostByIdApiV1BlogPostsIdGetRaw(requestParameters: ReadBlogPostByIdApiV1BlogPostsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlogPost>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readBlogPostByIdApiV1BlogPostsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/blog-posts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogPostFromJSON(jsonValue));
    }

    /**
     * Get a specific blog post by id.
     * Read Blog Post By Id
     */
    async readBlogPostByIdApiV1BlogPostsIdGet(requestParameters: ReadBlogPostByIdApiV1BlogPostsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlogPost> {
        const response = await this.readBlogPostByIdApiV1BlogPostsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve blog posts with optional filtering.
     * Read Blog Posts
     */
    async readBlogPostsApiV1BlogPostsGetRaw(requestParameters: ReadBlogPostsApiV1BlogPostsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BlogPost>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['categories'] != null) {
            queryParameters['categories'] = requestParameters['categories'];
        }

        if (requestParameters['tags'] != null) {
            queryParameters['tags'] = requestParameters['tags'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/blog-posts/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BlogPostFromJSON));
    }

    /**
     * Retrieve blog posts with optional filtering.
     * Read Blog Posts
     */
    async readBlogPostsApiV1BlogPostsGet(requestParameters: ReadBlogPostsApiV1BlogPostsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BlogPost>> {
        const response = await this.readBlogPostsApiV1BlogPostsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve blog posts with optional filtering.
     * Read Blog Posts
     */
    async readBlogPostsApiV1BlogPostsGet_2Raw(requestParameters: ReadBlogPostsApiV1BlogPostsGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BlogPost>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['categories'] != null) {
            queryParameters['categories'] = requestParameters['categories'];
        }

        if (requestParameters['tags'] != null) {
            queryParameters['tags'] = requestParameters['tags'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/blog-posts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BlogPostFromJSON));
    }

    /**
     * Retrieve blog posts with optional filtering.
     * Read Blog Posts
     */
    async readBlogPostsApiV1BlogPostsGet_2(requestParameters: ReadBlogPostsApiV1BlogPostsGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BlogPost>> {
        const response = await this.readBlogPostsApiV1BlogPostsGet_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a blog post.
     * Update Blog Post
     */
    async updateBlogPostApiV1BlogPostsIdPutRaw(requestParameters: UpdateBlogPostApiV1BlogPostsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlogPost>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBlogPostApiV1BlogPostsIdPut().'
            );
        }

        if (requestParameters['blogPostUpdate'] == null) {
            throw new runtime.RequiredError(
                'blogPostUpdate',
                'Required parameter "blogPostUpdate" was null or undefined when calling updateBlogPostApiV1BlogPostsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/blog-posts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BlogPostUpdateToJSON(requestParameters['blogPostUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogPostFromJSON(jsonValue));
    }

    /**
     * Update a blog post.
     * Update Blog Post
     */
    async updateBlogPostApiV1BlogPostsIdPut(requestParameters: UpdateBlogPostApiV1BlogPostsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlogPost> {
        const response = await this.updateBlogPostApiV1BlogPostsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
